export const colors = {
  black: '#1A1C21',
  borderColor: '#ECEDF0',
  componentFill: '#CDD8E6',
  darkGrey: '#525764',
  grey: '#9CA6B5',
  greyFocus: '#a9a9a9',
  iconInactive: '#A3A8B4',
  inactiveSideBarTab: '#E1E4EB',
  lightButtonHover: '#e5eafa9e',
  lightgray: '#bbbbbb',
  lightgrey: '#f2f2f2',
  lightPurple: '#ECEFFF',
  lightText: '#969BA5',
  linkWater: '#E5EAFA',
  middleGrey: '#D4D7DD',
  navLink: '#4B5EB0',
  notificationRead: '#FAFBFD',
  notificationUnRead: '#F0F3F7',
  oxford: '#707070',
  red: '#E9250C',
  sideBar: '#FAFBFD',
  silverGrey: '#F7F7F7',
  success: '#4056F4',
  transparent: 'transparent',
  user: {
    purple: {
      background: '#E2D9FB',
      text: '#5C40F4'
    },
    red: {
      text: '#F2453D'
    }
  },
  white: '#FFFFFF'
};
